import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import s from './SortSelect.scss';

const SelectDropdown = ({
  options,
  onSelect,
  selectedOption,
  placeHolder = '',
  sort = false,
  isWapView = false,
  typeTwoStyle,
  selected,
  active,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleToggle = e => {
    if (sort) {
      onSelect(e);
      return;
    }
    setIsOpen(!isOpen);
  };

  const handleSelect = option => {
    if (!sort) {
      onSelect(option);
    }
    setIsOpen(false);
  };

  const handleClickOutside = event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  return (
    <div
      className={`${s.sortWrap} ${s.filterWrap} ${
        typeTwoStyle ? s.typeTwo : ''
      } ${isOpen ? s.show : ''} ${
        !sort && options && Array.isArray(options) && options.length === 1
          ? s.gray
          : ''
      } ${selected ? s.selected : ''} ${active ? s.active : ''}`}
      onClick={
        options && Array.isArray(options) && options.length > 1
          ? handleToggle
          : null
      }
      ref={dropdownRef}
    >
      <div className={s.sortContent}>
        {sort && (
          <>
            <i className={s.sortIocn} onClick={onSelect} />
            {!isWapView && <>Sort By : </>}
          </>
        )}
        {
          <span>
            <span>{placeHolder ? `${placeHolder}: ` : ''}</span>{' '}
            {selectedOption?.name || ''}
          </span>
        }
        {!sort &&
          (options && Array.isArray(options) && options.length > 1) && (
            <i className={s.downArrowIcon} />
          )}
      </div>
      {!sort && (
        <ul className={`${s.sortList}`}>
          {options &&
            Array.isArray(options) &&
            options.length &&
            options.map(item => (
              <li
                onClick={() => handleSelect(item)}
                className={`${
                  item.name === selectedOption?.name ? s.active : ''
                }`}
              >
                {item.name}
              </li>
            ))}
        </ul>
      )}
    </div>
  );
};

SelectDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedOption: PropTypes.string.isRequired,
};

export default SelectDropdown;
